var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.waggon)?_c('StandardDialogFullScreen',{attrs:{"opacity":"1"},scopedSlots:_vm._u([{key:"dialog",fn:function(){return [(_vm.$route.matched[3] && _vm.$route.matched[3].name !== 'WorkBenchWaggonWorkPackageAdd')?_c('router-view',{staticStyle:{"z-index":"20","background-color":"red"}}):_vm._e()]},proxy:true},{key:"header-workpackages",fn:function(){return [(_vm.show_dialog)?_c('StandardDialog',{on:{"click-outside":function($event){_vm.show_dialog=false}},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('v-card',{staticClass:"d-flex flex-column",attrs:{"color":"secondary","height":"100%"}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t('WorkBench.Editor.Download.Header').replace('Sequence', 'Wagon'))+" ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t('WorkBench.Editor.Download.Text').replace('sequence', 'wagon'))+" ")]),_c('v-spacer'),_c('v-card-actions',[(_vm.template_type==='community')?_c('v-btn',{attrs:{"color":"green","text":""},on:{"click":function($event){_vm.createWBObject({
              url: [
                {waggons: '0/copyfromcommunity'},
                {showWithEntitiesNormalized: ''},
              ],
              wb_object: {
                cwaggon: _vm.waggon.id,
                copy_workpackages: true
              }
            }).then(() => {
              _vm.waggon.likes.some(like => like.user.id === _vm.getUserId)?
              _vm.show_dialog=false:
              _vm.updateWBObject({
                url: [
                {cwaggons: _vm.waggon.id},
                {like: ''},
                ],
                update: {
                  likes: _vm.getLikes(_vm.waggon.likes)
                }
              }).then(() => { _vm.show_dialog=false; })
            })}}},[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Download.WithWorkPackages').replace('Sequence', 'wagon')))]):_vm._e(),(_vm.template_type==='community')?_c('v-btn',{attrs:{"color":"green","text":""},on:{"click":function($event){_vm.createWBObject({
              url: [
                {waggons: '0/copyfromcommunity'},
                {showWithEntitiesNormalized: ''},
              ],
              wb_object: {
                cwaggon: _vm.waggon.id,
                copy_workpackages: false
              }
            }).then(() => {
              _vm.waggon.likes.some(like => like.user.id === _vm.getUserId)?
              _vm.show_dialog=false:
              _vm.updateWBObject({
                url: [
                {cwaggons: _vm.waggon.id},
                {like: ''},
                ],
                update: {
                  likes: _vm.getLikes(_vm.waggon.likes)
                }
              }).then(() => { _vm.show_dialog=false; })
            })}}},[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Download.WithoutWorkPackages').replace('Sequence', 'wagon')))]):_vm._e(),(_vm.template_type==='company')?_c('v-btn',{attrs:{"color":"green","text":""},on:{"click":function($event){_vm.createWBObject({
              url: [
                {waggons: '0/copyfrombusiness'},
                {showWithEntitiesNormalized: ''},
              ],
              wb_object: {
                bwaggon: _vm.waggon.id,
                copy_workpackages: true
              }
            }).then(() => {
              _vm.waggon.likes.some(like => like.user.id === _vm.getUserId)?
              _vm.show_dialog=false:
              _vm.updateWBObject({
                url: [
                {bwaggons: _vm.waggon.id},
                {like: ''},
                ],
                update: {
                  likes: _vm.getLikes(_vm.waggon.likes)
                }
              }).then(() => { _vm.show_dialog=false; })
            })}}},[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Download.WithWorkPackages').replace('Sequence', 'wagon')))]):_vm._e(),(_vm.template_type==='company')?_c('v-btn',{attrs:{"color":"green","text":""},on:{"click":function($event){_vm.createWBObject({
              url: [
                {waggons: '0/copyfrombusiness'},
                {showWithEntitiesNormalized: ''},
              ],
              wb_object: {
                bwaggon: _vm.waggon.id,
                copy_workpackages: false
              }
            }).then(() => {
              _vm.waggon.likes.some(like => like.user.id === _vm.getUserId)?
              _vm.show_dialog=false:
              _vm.updateWBObject({
                url: [
                {bwaggons: _vm.waggon.id},
                {like: ''},
                ],
                update: {
                  likes: _vm.getLikes(_vm.waggon.likes)
                }
              }).then(() => { _vm.show_dialog=false; })
            })}}},[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Download.WithoutWorkPackages').replace('Sequence', 'wagon')))]):_vm._e(),_c('v-spacer'),_c('v-btn',{attrs:{"color":"red","text":""},on:{"click":function($event){_vm.show_dialog=false}}},[_vm._v("Cancel")])],1)],1)]},proxy:true}],null,false,2560636424)}):_vm._e(),(!_vm.create)?_c('StandardFlexBox',{staticClass:"font-weight-light",attrs:{"direction":"column"}},[_c('TText',{attrs:{"value":"Creator{colon} {firstName} {lastName} - {email}","value_props":{
          colon: ':',
          firstName: _vm.waggon.owner.first_name,
          lastName: _vm.waggon.owner.last_name,
          email: _vm.waggon.owner.email,
        },"font_weight":"400"}})],1):_vm._e(),_c('StandardFlexBox',{staticClass:"font-weight-light ml-6",attrs:{"width":"calc(100vw - 450px)"}},[_vm._l((_vm.waggon.hashtags),function(hashtag,index){return _c('StandardDataField',{key:index,staticClass:"user-select-none ml-1",attrs:{"color":_vm.$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3',"text_color":_vm.$vuetify.theme.isDark ? 'white' : 'black',"one_liner":"true","readonly":"true","value":hashtag.tag,"width":"24%"},scopedSlots:_vm._u([{key:"prepend-slot",fn:function(){return [_c('div',{staticClass:"user-select-none"},[_vm._v("#")])]},proxy:true},{key:"append-slot",fn:function(){return [_c('StandardDeleteButton',{attrs:{"zoom":1},on:{"clickDelete":function($event){_vm.create?
            _vm.deleteWBLObject({
              path: [
                {waggon: ''},
                {hashtags: ''}
              ],
              index: index
              })
            :
            _vm.removeHashtag(index)}}})]},proxy:true}],null,true)})}),(!_vm.read_only)?_c('StandardDataField',{key:`addhashtag_${_vm.update_key_add_hashtag}`,staticClass:"ml-1",attrs:{"color":_vm.$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3',"text_color":_vm.$vuetify.theme.isDark ? 'white' : 'black',"one_liner":"true"},on:{"changeValue":function($event){_vm.create?
        _vm.createWBLObject({
          path: [
            {waggon: ''},
            {hashtags: ''}
          ],
          wbl_object: {
            tag: $event.replace(/\s/g,'')
          }
          })
        :
        _vm.addHashtag($event),
        _vm.update_key_add_hashtag++}},scopedSlots:_vm._u([{key:"prepend-slot",fn:function(){return [_c('div',{staticClass:"user-select-none"},[_vm._v("#")])]},proxy:true}],null,false,2005579542)}):_vm._e()],2)]},proxy:true},{key:"header-close",fn:function(){return [(!_vm.create)?[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.$router.push({
              name: `${_vm.location}Waggons`
              })}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("done")])],1)]}}],null,false,879669374)},[_c('span',[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Waggon.Toolbar.done')))])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(!_vm.read_only && _vm.$route.params.template_type === 'custom')?_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){_vm.createWBObject({
            url: [
              {[`${_vm.prefix}waggons`]: _vm.waggon.id},
              {copyOwnWaggon: ''}
            ],
            wb_object: {
              cwaggon: _vm.waggon.id
            },
            url_suffix: '?show=showWithEntitiesNormalized'
            }).then(() => {
              _vm.$router.push({
                name: `${_vm.location}Waggons`
              })
            })}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("content_copy")])],1):_vm._e()]}}],null,false,1196512704)},[_c('span',[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Waggon.Toolbar.copy')))])]),(!_vm.read_only)?_c('TUploadButton',{attrs:{"icon":"people","value":_vm.waggon.is_community_suggested,"tooltip":_vm.$t('WorkBench.Editor.Waggon.Toolbar.uploadToCommunity')},on:{"upload":function($event){return _vm.updateWBObject({
          url: [
            {[`${_vm.prefix}waggons`]: _vm.waggon_id},
          ],
          update: {
            is_community_suggested: true
          }
        })}}}):_vm._e(),(_vm.template_type === 'community')?[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"text":"","color":_vm.waggon.likes.some(like => like.user.id === _vm.getUserId)?'blue':'grey'},on:{"click":function($event){_vm.show_dialog=true}}},'v-btn',attrs,false),on),[_c('v-icon',{staticClass:"mr-5"},[_vm._v("download")]),_vm._v(" "+_vm._s(_vm.waggon.likes.length)+" ")],1)]}}],null,false,3606460205)},[_c('span',[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Waggon.Toolbar.download')))])])]:_vm._e(),(_vm.template_type === 'company')?[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"text":"","color":_vm.waggon.likes.some(like => like.user.id === _vm.getUserId)?'blue':'grey'},on:{"click":function($event){_vm.show_dialog=true}}},'v-btn',attrs,false),on),[_c('v-icon',{staticClass:"mr-5"},[_vm._v("download")]),_vm._v(" "+_vm._s(_vm.waggon.likes.length)+" ")],1)]}}],null,false,3606460205)},[_c('span',[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Waggon.Toolbar.download')))])])]:_vm._e(),(!_vm.read_only && _vm.hasPermission('Business READ') && _vm.template_type !== 'company')?[_c('TUploadButton',{attrs:{"icon":"work","counter":_vm.getWBObjectsFiltered({type: 'bwaggons',
            filter: {
              token: _vm.waggon.token,
              owner: _vm.waggon.owner
            }
          }).length,"tooltip":_vm.$t('WorkBench.Editor.Waggon.Toolbar.uploadToCompany')},on:{"upload":function($event){return _vm.createWBObject({
              url: [
                {bwaggons: 'createfromwaggon'},
                {showWithEntitiesNormalized: ''}
              ],
              template_type: 'company',
              wb_object: {
                waggon_id: _vm.waggon.id
              }
            })}}})]:_vm._e(),(
          !_vm.read_only ||
          (_vm.template_type === 'company' && _vm.hasPermission('BSequence DELETE')) ||
          (_vm.template_type === 'community' && _vm.hasPermission('CSequence DELETE'))
          )?_c('StandardDeleteBtn',{attrs:{"tooltip":_vm.$t('WorkBench.Editor.Waggon.Toolbar.delete'),"el":_vm.waggon},on:{"deleteClick":function($event){_vm.deleteWBObject({
              url: [
                {[`${_vm.prefix}waggons`]: _vm.waggon.id}
              ]
            }),
            _vm.$router.push({
              name: `${_vm.location}Waggons`
              })}}}):_vm._e()]:[_c('v-btn',{attrs:{"color":"orange"},on:{"click":function($event){return _vm.resetWaggon()}}},[_c('v-icon',[_vm._v(" restart_alt ")]),_vm._v(" Reset ")],1),_c('v-spacer'),_c('v-btn',{staticClass:"ml-2",attrs:{"color":"green"},on:{"click":function($event){_vm.loading = true,
        _vm.createWBObject({
            url: [
              {waggons: ''},
              {showWithEntitiesNormalized: ''}
            ],
            wb_object: _vm.getWaggonForCreateCall()
          }).then((id) => {
            _vm.uploadWaggonWorkpackagesImageBulk(id)
            })}}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('Buttons.Create'))+" ")],1),_c('v-btn',{staticClass:"ml-2",attrs:{"depressed":"","color":"grey darken-4"},on:{"click":function($event){return _vm.$router.push({
          name: `${_vm.location}Waggons`
          })}}},[_vm._v(" "+_vm._s(_vm.$t('Buttons.Cancel'))+" ")])]]},proxy:true},{key:"content",fn:function(){return [_c('StandardFlexBox',{staticClass:"mb-1",staticStyle:{"position":"relative"},attrs:{"width":"100%","height":"346px","direction":"column"}},[_c('StandardFlexBox',{staticClass:"mr-1 ml-1 mt-1 overflow-visible",staticStyle:{"position":"relative"},attrs:{"height":"42px","no_wrap":"true"}},[_c('Waggon',{staticClass:"cursor-pointer",style:(`${
                  (_vm.$route.matched[3] && _vm.$route.matched[3].name === `${_vm.location}WaggonWorkPackageAdd` &&
                  _vm.$route.params.waggon_id === (_vm.create?0:_vm.waggon.id))
                  || !_vm.$route.matched[3] && _vm.wagworkpackage_rec_pos === 0 ||
                  _vm.wagworkpackage_rec_pos !== 0 && (_vm.wagworkpackage_rec_pos === 0+1 || _vm.wagworkpackage_rec_pos === 0+2) ||
                  _vm.wagworkpackage_rec_pos !== 0 && _vm.wagworkpackage_rec_pos > _vm.waggon[`${_vm.prefix}wagworkpackages`].length && 0 === _vm.waggon[`${_vm.prefix}wagworkpackages`].length-1
                  ?
                  '': 'opacity: 0.5;'
                  }
                  transition: opacity 0.2s ease-in-out;
                   `),attrs:{"workpackage_count":_vm.waggon[`${_vm.prefix}wagworkpackages`].length,"zoom":4},nativeOn:{"click":function($event){_vm.waggon[`${_vm.prefix}wagworkpackages`].length === 0 ? _vm.$router.push({
            name: `${_vm.location}WaggonWorkPackageAdd`,
            params: {
              waggon_id: _vm.create ? 'create' : _vm.waggon.id,
            }
          }) : ''}},scopedSlots:_vm._u([{key:"content",fn:function(){return _vm._l((_vm.create?_vm.waggon.wagworkpackages:_vm.getWBObjects({type: `${_vm.prefix}wagworkpackages`, ids: _vm.waggon[`${_vm.prefix}wagworkpackages`]})),function(workpackage,workpackage_index){return _c('Workpackage',{key:`workpackage${_vm.create?workpackage_index:workpackage.id}`,attrs:{"workpackage_count":_vm.waggon[`${_vm.prefix}wagworkpackages`].length,"workpackage":workpackage,"zoom":4},nativeOn:{"click":function($event){return _vm.workpackageTestClick(workpackage_index)}}})})},proxy:true}],null,false,1996545913)})],1)],1),_c('StandardFlexBox',{class:`ml-1 mr-1 pa-1 t-rounded t-shadow font-weight-light ${_vm.$vuetify.theme.isDark ? 'grey darken-4' : 'grey lighten-3'}`,attrs:{"height":"calc(100% - 350px)"}},[(_vm.$route.matched[3] && _vm.$route.matched[3].name === 'WorkBenchWaggonWorkPackageAdd')?[_c('StandardFlexBox',{staticClass:"cursor-pointer",attrs:{"height":"100%","width":"40px","direction":"column","justify_content":"center","align_content":"center"},nativeOn:{"click":function($event){return _vm.$router.push({name: `${_vm.location}WaggonEditor`})}}},[_c('v-icon',[_vm._v("keyboard_arrow_left")])],1),_c('StandardFlexBox',{attrs:{"height":"100%","width":"calc(100% - 40px)","direction":"column","justify_content":"space-between"}},[_c('router-view',{staticStyle:{"z-index":"20"}})],1)]:_c('StandardFlexBox',{staticClass:"pa-1",attrs:{"width":"30%","height":"100%"}},[_c('StandardDataField',{attrs:{"placeholder":"token","width":"100%","height":"26px","color":_vm.$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3',"text_color":_vm.$vuetify.theme.isDark ? 'white' : 'black',"value":_vm.waggon.token,"readonly":_vm.read_only,"maxlength":5},on:{"changeValue":function($event){_vm.create?
          _vm.updateWBLObject({
            path: [
              {waggon: ''},
            ],
            update: {
              token: $event
            }
            })
          :
          _vm.updateWBObject({
            url: [
              {[`${_vm.prefix}waggons`]: _vm.waggon_id},
            ],
            update: {
              token: $event
            }
          })}}})],1)],2)]},proxy:true}],null,false,366338492)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }